import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import DataTable from "../../component/DataTable";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";

const tableHeader = ["Date", "Title", "Slug"];
const tbody = ["date", "title", "slug"];

export default function ComparisonListing() {
  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", ApiEndpoints.comparison.List);
      setData(response.comparisons || []);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (comparison_id) => {
    try {
      const response = await ApiRequest("POST", ApiEndpoints.comparison.Delete, { comparison_id });
      toast.success(response.message);
      dataFetch();
    } catch (error) {
      console.error(error);
    }
  };

  const pagename = {
    name: "Comparison page",
    user: "Admin",
    innerpage: "Comparison page",
  };

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-comparison">Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath="edit-comparison"
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
